import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-contributor-section',
    templateUrl: './contributor-section.component.html',
    styleUrls: ['./contributor-section.component.scss'],
    standalone: false
})
export class ContributorSectionComponent implements OnInit {

  @Input() contributor;

  constructor() {}

  ngOnInit(): void {}

}